import { render, staticRenderFns } from "./BrandMessaging.vue?vue&type=template&id=6b2fb03a"
import script from "./BrandMessaging.vue?vue&type=script&lang=js"
export * from "./BrandMessaging.vue?vue&type=script&lang=js"
import style0 from "./BrandMessaging.vue?vue&type=style&index=0&id=6b2fb03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports